import type { Args } from 'webapp/components/templates/public/recommended-boards';
import TemplatesPublicRecommendedBoardsComponent from 'webapp/components/templates/public/recommended-boards';

export default class TemplatesAccountRecommendedBoardTemplates<
	T extends Args,
> extends TemplatesPublicRecommendedBoardsComponent<T> {
	override defaultOrigin = 'recommended_account_templates';

	override get title() {
		return 'Start by creating the first dashboard using public templates...';
	}
}
